import {
   GET_SALE_CHALLAN,
   ADD_SALE_CHALLAN,
   UPDATE_SALE_CHALLAN,
   GET_SALE_CHALLAN_BY_ID,
   DELETE_SALE_CHALLAN,
   GET_LAST_SALE_CHALLAN_DAYBOOK,
   GET_ORDER_DOCUMENT,
   GET_CHALLAN_DOCUMENT,
} from '../types';

const initialState = {
   list: [],
   single: null,
   totalCount: 0,
   lastBill: null,
   isLoading: false,
   pagination: {
      limit: 10,
      nextPage: null,
      totalPages: 1,
      currentPage: 1,
      hasNextPage: false,
      previousPage: null,
      totalProducts: 0,
      hasPreviousPage: false,
   },
   salesData: null,
   prevAndNext: null,
   pendingVoucherSalesAdjustment: [],
   pendingSalesAdjustment: [],
   pendingPurchaseAdjustment: [],
   pendingVoucherPurchaseAdjustment: [],
};

const reducer = (state = initialState, action) => {
   const { type, payload, totalCount } = action;

   switch (type) {
      case GET_SALE_CHALLAN:
         return { ...state, list: payload.data, totalCount: totalCount, isLoading: false, pagination: action.payload.pagination };

      case GET_SALE_CHALLAN_BY_ID:
         return { ...state, single: payload || initialState.single, isLoading: false };

      case UPDATE_SALE_CHALLAN:
         return { ...state, list: state.list.map((item) => (item.id === payload.id ? payload : item)), isLoading: false };

      case ADD_SALE_CHALLAN:
         return { ...state, list: [payload, ...state.list], totalCount: state.totalCount + 1, isLoading: false };

      case DELETE_SALE_CHALLAN:
         return { ...state, list: state.list.filter((item) => item.id !== payload.id), totalCount: state.totalCount - 1, isLoading: false };

      case GET_LAST_SALE_CHALLAN_DAYBOOK:
         return { ...state, lastSaleDaybook: payload };

      case GET_ORDER_DOCUMENT:
         return { ...state, orderDocument: payload.data };

      case GET_CHALLAN_DOCUMENT:
         return { ...state, challanDocument: payload.data };

      default:
         return state;
   }
};

export default reducer;
